import { type CSSProperties, forwardRef, type HTMLAttributes } from 'react';
import {
  kaiFontFamily,
  styleguideColors,
  styleguideElevation,
  styleguideRadius,
  styleguideSpacing,
} from '../../../core/tokens';
import { resolveStyleOverride, type StyleOverride } from '../../styleOverrides';

export type CardVariant = 'elevated' | 'outlined';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant;
  styleOverride?: StyleOverride;
}

const CARD_STYLE: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: styleguideSpacing.s2,
  minWidth: 0,
  padding: styleguideSpacing.s4,
  border: `1px solid ${styleguideColors.stroke}`,
  borderRadius: styleguideRadius.sharp,
  background: styleguideColors.white,
  color: styleguideColors.ink,
  fontFamily: kaiFontFamily,
};

export const Card = forwardRef<HTMLDivElement, CardProps>(({
  variant = 'elevated',
  styleOverride: cardCss,
  style,
  ...props
}, ref) => (
  <div
    ref={ref}
    style={{
      ...CARD_STYLE,
      boxShadow: variant === 'elevated' ? styleguideElevation.card : 'none',
      ...style,
      ...resolveStyleOverride(cardCss),
    }}
    {...props}
  />
));

Card.displayName = 'Card';
